<template>
  <div>
    <Supervision_app_bar />
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="กำหนดการปฏิทินการสมัคร คัดเลือก ตำแหน่ง ศึกษานิเทศก์"
        class="px-5 py-3"
      >
        <v-card class="mb-4 pa-2">
          <v-row>
            <v-col cols="12" md="12">
              <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item color="grey lighten-1" fill-dot left small>
                  <v-card>
                    <v-card-title class="grey lighten-1 justify-end">
                      <h2 class="mr-4 white--text font-weight-light">
                        กำหนดการ <span class="error--text">ประกาศสมัคร</span>
                      </h2>
                      <v-icon dark size="42">
                        mdi-calendar
                      </v-icon>
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="12">
                          <PeriodSupervisionNotice />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </v-card>
      </base-material-card>
    </v-container>
  </div>
</template>

<script>
import PeriodSupervisionNotice from "../../../components/admin/periodSupervisionNotice.vue";
import Supervision_app_bar from "../../../components/admin/supervision_app_bar.vue";

export default {
  name: "HRvecTransferTeachers",
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021"
    };
  },
  mounted() {},
  methods: {},
  components: { 
    PeriodSupervisionNotice,
    Supervision_app_bar
  }
};
</script>

<style lang="scss" scoped></style>
